export const MATCH_LOCALE_STORAGE_KEY = 'ffl_match_locale';
export const SUPPORTED_MATCH_LOCALES = ['en', 'es'] as const;

export type MatchLocale = (typeof SUPPORTED_MATCH_LOCALES)[number];

export function normalizeMatchLocale(
  value: string | null | undefined,
): MatchLocale {
  const language = value?.trim().toLowerCase().split(/[-_]/)[0];
  return language === 'es' ? 'es' : 'en';
}

export function isSupportedMatchLocale(value: string): value is MatchLocale {
  return SUPPORTED_MATCH_LOCALES.includes(value as MatchLocale);
}
